import { useMemo } from 'react'
import cns from 'classnames'
import { Loan } from 'modules/pools/types/Loan'

// eslint-disable-next-line css-modules/no-unused-class
import s from './LoanStatusBadge.module.scss'

// 0: UNISSUED
// 1 NEW: is set by default when loan is configured
// 2 APPROVED: is set when loan is fulfilled by the Investor
// 3 PAIDPART: is set after loan is repaid partially
// 4 CLOSED: is repaid in full
// 5 PAIDLATE: is set when repaid after maturity date + grace period
// 6 DEFAULT: is set when loan is liquidated
// 7: LATE: is set for loans which are late, but not paid yet

type Props = {
  loan: Loan
}

export const LoanStatusBadge = ({ loan }: Props) => {
  const statusData = useMemo(() => {
    switch (loan.status) {
      case 0:
        return { text: 'Unissued', color: 'yellow' }
      case 1:
        return { text: 'New', color: 'green' }
      case 2:
        return { text: 'Active', color: 'green' }
      case 3:
        return { text: 'Partially repaid', color: 'green' }
      case 4:
        return { text: 'Fully repaid', color: 'green' }
      case 5:
        return { text: 'Late partially repaid', color: 'yellow' }
      case 6:
        return { text: 'In Debt', color: 'red' }
      case 7:
        return { text: 'Expecting repayment', color: 'yellow' }
      default:
        return { text: 'Unknown', color: 'yellow' }
    }
  }, [loan.status])

  return (
    <div className={cns(s.root, s[`color--${statusData.color}`])}>
      {statusData.text}
    </div>
  )
}
